// extracted by mini-css-extract-plugin
export var root = "iCqV";
export var rootIcons = "WR7T";
export var rootLabel = "UuJI";